/* eslint-disable */

$('.pi__documents').click(function() {

  var id = $(this).attr('id');

  var $wrapper = $('#' + id).children('.pi__info');

  var $container = $('#' + id).children('.pi__ajax_content');

  if($(this).hasClass('active')) {
    $(this).removeClass('active');
    $wrapper.slideUp();
    $container.empty();
  } else {
    $(this).addClass('active');
    jQuery.ajax({
      type       : "GET",
      data       : { 
        dataType   : "jsonp",
        action:'ajax_pi_research_documents',
        pi_id: id,
        current_site: current_site,
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        if(data.length) {
          var content = data;
          $wrapper.hide().slideDown();
          $(content).hide().appendTo($container).slideDown();
        }
      },
    });
  }
});

// Ajax Research Documents Sponsors

$('.research-documents #researchTabs li a[data-target="#sponsor"]').click(function() {
  var $sponsor_container = $('.ajax__docs_sponsor_content');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_sponsor_research_documents',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        data = JSON.parse(data);
        var content = data[0];
        var first_char_sponsor = data[1];

        $sponsor_container.empty();
        $(content).hide().appendTo($sponsor_container).fadeIn(300);

        for (var i = 0; i < first_char_sponsor.length; i++) {
          $('[data-filter="' + first_char_sponsor[i] + '"]').removeClass('disabled');
          $('[data-filter="' + first_char_sponsor[i] + '"]').attr('href', '#sponsor-' + first_char_sponsor[i]);
        }

      }
    },
  });

})

// Ajax Research Focus Areas

$('.research-documents #researchTabs li a[data-target="#focusarea"]').click(function() {
  var $focusarea_container = $('.ajax__docs_focus_area_content');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_focus_area_research_documents',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $focusarea_container.empty();
        $(content).appendTo($focusarea_container).fadeIn(300);

      }
    },
  });

})

// Ajax Research End Date

$('.research-documents #researchTabs li a[data-target="#enddate"]').click(function() {
  var $enddate_container = $('.ajax__docs_end_date_content');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_end_date_research_documents',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $enddate_container.empty();
        $(content).appendTo($enddate_container).fadeIn(300);

      }
    },
  });

})

// Ajax Research Start Date

$('.research-documents #researchTabs li a[data-target="#startdate"]').click(function() {
  var $startdate_container = $('.ajax__docs_start_date_content');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_start_date_research_documents',
      current_site: current_site,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;

        $startdate_container.empty();
        $(content).appendTo($startdate_container).fadeIn(300);

      }
    },
  });

})


// WEBPACK FOOTER //
// ./scripts/routes/research-documents.js